module.exports = __webpack_public_path__ + "img/share.cdf033ee.png";